import { IFilter, Operator } from 'core-components/types'

export const FILTER_FOR_CATEGORY_TOPIC: IFilter = {
  operator: Operator.ISNULL,
  field: 'CategoryTopic',
  value: '',
}
